import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Andrés R.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'María C.',
  location: 'CDMX, México'
}, {
  name: 'Juan P.',
  location: 'Bogotá, Colombia'
}, {
  name: 'Fernando L.',
  location: 'Santiago, Chile'
}, {
  name: 'Valeria T.',
  location: 'Lima, Perú'
}, {
  name: 'Carlos R.',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Sofía M.',
  location: 'Quito, Ecuador'
}, {
  name: 'Daniel G.',
  location: 'Caracas, Venezuela'
}, {
  name: 'Laura P.',
  location: 'Guatemala'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[260px] md:max-w-[280px]" data-id="element-192">
      <div className="bg-brand-card rounded-lg shadow-[0_0_30px_rgba(0,255,136,0.4)] border-2 border-brand-accent p-3 flex items-start gap-3 relative overflow-hidden" data-id="element-193">
        <div className="bg-brand-accent p-1.5 rounded-full shrink-0 mt-0.5 shadow-[0_0_10px_rgba(0,0,0,0.5)]" data-id="element-194">
          <CheckCircle className="w-4 h-4 text-brand-dark" data-id="element-195" />
        </div>
        <div data-id="element-196">
          <p className="text-[10px] md:text-xs text-gray-200 font-bold leading-tight mb-1 uppercase" data-id="element-197">
            <span className="font-black text-brand-accent" data-id="element-198">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.location} acaba de comprar el Kit Filosofía 📜
          </p>
          <p className="text-[9px] text-gray-400 font-black tracking-widest uppercase" data-id="element-199">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-200">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}